
const config = {
    system: {
        maxInt: 2147483647,
    },
    app: {
        version: "1.0.3",
        cacheName: "ChatbotCache",
        amountPerPage: "10",
        amountPerPageArray: [5, 10, 15, 20, 25, 30, 40, 50],
        cultureCode: "en-GB",
        get apiBaseUrl() {
            return getConfig().apiBaseUrl;
        },
        get redirectUri() {
            return getConfig().redirectUri;
        },
        get environmentClass() {
            return getConfig().environmentClass;
        },
        get authRealm(){
            return getConfig().authRealm;
        },
        get authClientId(){
            return getConfig().authClientId;
        },
        get authIdpHint(){
            return getConfig().authIdpHint;
        },
        get authUrl(){
            return getConfig().authUrl;
        }
    }
}


function getConfig() {
    if (window.location.href.indexOf("https://shoeby-chatbot-app.azurewebsites.net/") !== -1) { 
        return { // Production env.
            apiBaseUrl: "https://shoeby-api.azurewebsites.net/api/",
            redirectUri: "https://shoeby-chatbot-app.azurewebsites.net/signin-oidc",
            authUrl: "https://shoeby-keycloak-prod.azurewebsites.net/auth/",
            authRealm: "Shoeby-chatbot-prod",
            authClientId: "chatbot-app",
            authIdpHint: "shoeby-azure-saml",
            environmentClass: "env-prod",
        };
    } else if (window.location.href.indexOf("https://chatbot.shoeby.app/") !== -1) { 
        return { // Production env. 2
            apiBaseUrl: "https://api.shoeby.app/api/",
            redirectUri: "https://chatbot.shoeby.app/signin-oidc",
            authUrl: "https://shoeby-keycloak-prod.azurewebsites.net/auth/",
            authRealm: "Shoeby-chatbot-prod",
            authClientId: "chatbot-app",
            authIdpHint: "shoeby-azure-saml",
            environmentClass: "env-prod",
        }
    } else if (window.location.href.indexOf("https://shoeby-chatbot-app-test.azurewebsites.net/") !== -1) { 
        return { // Test/Staging env.
            apiBaseUrl: "https://shoeby-api-test.azurewebsites.net/api/",
            redirectUri: "https://shoeby-chatbot-app-test.azurewebsites.net/signin-oidc",
            authUrl: "https://shoeby-keycloak-test.azurewebsites.net/auth/",
            authRealm: "Shoeby-chatbot-test",
            authClientId: "chatbot-app",
            authIdpHint: "shoeby-azure-saml",
            environmentClass: "env-test",
        }
    } else if (window.location.href.indexOf("https://chatbot-test.shoeby.app/") !== -1) { 
        return { // Test/Staging env. 2
            apiBaseUrl: "https://api-test.shoeby.app/api/",
            redirectUri: "https://chatbot-test.shoeby.app/signin-oidc",
            authUrl: "https://shoeby-keycloak-test.azurewebsites.net/auth/",
            authRealm: "Shoeby-chatbot-test",
            authClientId: "chatbot-app-sso",
            authIdpHint: "",
            environmentClass: "env-test",
        }
    } else {
        return { // Local env.
            apiBaseUrl: "https://api-dev.shoeby.app/api/",
            //apiBaseUrl: "https://localhost:5001/api/",
            redirectUri: "http://localhost:2000/",
            authUrl: "https://shoeby-keycloak-dev.azurewebsites.net/auth/",
            authRealm: "Shoeby-chatbot-dev",
            authClientId: "chatbot-app",
            authIdpHint: "shoeby-azure-saml",
            environmentClass: "env-local",
        };
    }
}
export default config;
